// extracted by mini-css-extract-plugin
export default {"subscriptionFeatureCollapse":"SubscriptionFeatureCollapse_subscriptionFeatureCollapse__LkW7O","mobile":"SubscriptionFeatureCollapse_mobile__Vj4NW"};